import { FC, useEffect } from 'react';

import { getStaticPrefix } from '@eneco/common/env';
import useDC from '@eneco/dc/useDC';
import { I18nProvider, useTranslation } from '@eneco/i18n';
import { Skeleton } from '@eneco/sparky';
import { useTracking } from '@eneco/tracking';

import { useMeterReadingsFlow } from '../../../../state/MeterReadingsFlow.machine';
import { Steps } from '../../../../tracking';
import { Simple } from '../../../templates/Simple';

export const RelocationNewAddress: FC = () => {
  const { label } = useDC();

  return (
    <I18nProvider dictionary={locale => import(`./content/RelocationNewAddress.${label}.${locale}.json`)}>
      <RelocationNewAddressComponent />
    </I18nProvider>
  );
};

export const RelocationNewAddressComponent: FC = () => {
  const { label } = useDC();
  const { t, isLoading } = useTranslation();
  const { trackFunnelCompleted } = useTracking();
  const { state } = useMeterReadingsFlow();

  useEffect(() => {
    trackFunnelCompleted({
      step: Steps['THANK_YOU.RelocationNewAddress'],
      funnel: state.context.funnelName,
    });
  }, [state.context.funnelName, trackFunnelCompleted]);

  if (isLoading) return <Skeleton height={450} />;

  return (
    <Simple
      title={t('relocationNewAddress.title')}
      content={t('relocationNewAddress.content')}
      buttonHref={t('relocationNewAddress.buttonLink.href')}
      buttonText={t('relocationNewAddress.buttonLink.text')}
      nextStepList={[
        {
          label: t('relocationNewAddress.nextStep1'),
          state: 0,
        },
        {
          label: t('relocationNewAddress.nextStep2'),
          state: 0,
        },
        {
          label: t('relocationNewAddress.nextStep3'),
          state: 1,
        },
        {
          label: t('relocationNewAddress.nextStep4'),
          state: 1,
        },
      ]}
      heroImage={{
        value: {
          src: `${getStaticPrefix()}/images/${label}/meterreadings/${t('relocationNewAddress.imageSrc')}`,
        },
      }}
    />
  );
};
